import { FormikTextField } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import * as React from 'react'
import * as Yup from 'yup'

export class ProvingDetailsAmountFormValues {}

export const AmountFormSchema = Yup.object().shape({
  amount: Yup.number().required(),
})

export const ProvingDetailsAmountForm: React.FunctionComponent = () => {
  // const { t } = useTranslation()

  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name={'amount'}
          render={(fieldProps) => (
            <FormikTextField
              label={'Anzahl'}
              type={'number'}
              min={1}
              max={30}
              step={1}
              {...fieldProps}
            />
            // <FormikSpinButton
            //   label={'Anzahl'}
            //   labelPosition={Position.top}
            //   min={1}
            //   max={30}
            //   step={1}
            //   {...fieldProps}
            // />
          )}
        />
      </FieldStack>
    </FormStack>
  )
}
